"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[8101],{

/***/ 64303:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41964);
/* harmony import */ var core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5119);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94218);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40045);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51497);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}





var CouponApplyDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "CouponApply"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "CouponApplyInput"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "validateOnly"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Boolean"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "gender"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "UserGender"
                        }
                    }
                }
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "couponApply"
                        },
                        "arguments": [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "data"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "totalAmount"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "coupon"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "type"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "code"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "discountAmount"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "discountPercentage"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "shouldCharge"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "chargeAmount"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "extraShippingPrice"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "marketingCouponOfferType"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "origin"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "freeProduct"
                                                            },
                                                            "arguments": [
                                                                {
                                                                    kind: "Argument",
                                                                    name: {
                                                                        kind: "Name",
                                                                        value: "gender"
                                                                    },
                                                                    value: {
                                                                        kind: "Variable",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "gender"
                                                                        }
                                                                    }
                                                                }
                                                            ],
                                                            directives: [
                                                                {
                                                                    kind: "Directive",
                                                                    name: {
                                                                        kind: "Name",
                                                                        value: "include"
                                                                    },
                                                                    "arguments": [
                                                                        {
                                                                            kind: "Argument",
                                                                            name: {
                                                                                kind: "Name",
                                                                                value: "if"
                                                                            },
                                                                            value: {
                                                                                kind: "Variable",
                                                                                name: {
                                                                                    kind: "Name",
                                                                                    value: "validateOnly"
                                                                                }
                                                                            }
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "brandInfo"
                                                                        },
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "name"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "image"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "rebrandImage"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "name"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "typeGroup"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "rating"
                                                                        },
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "avgRate"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "couponApplyPeriod"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "error"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                    kind: "NamedType",
                                                    name: {
                                                        kind: "Name",
                                                        value: "SecurityError"
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            alias: {
                                                                kind: "Name",
                                                                value: "securityErrorCode"
                                                            },
                                                            name: {
                                                                kind: "Name",
                                                                value: "errorCode"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                    kind: "NamedType",
                                                    name: {
                                                        kind: "Name",
                                                        value: "CouponError"
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            alias: {
                                                                kind: "Name",
                                                                value: "couponErrorCode"
                                                            },
                                                            name: {
                                                                kind: "Name",
                                                                value: "errorCode"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                    kind: "NamedType",
                                                    name: {
                                                        kind: "Name",
                                                        value: "ServerError"
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            alias: {
                                                                kind: "Name",
                                                                value: "serverErrorCode"
                                                            },
                                                            name: {
                                                                kind: "Name",
                                                                value: "errorCode"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                    kind: "NamedType",
                                                    name: {
                                                        kind: "Name",
                                                        value: "BusinessError"
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            alias: {
                                                                kind: "Name",
                                                                value: "businessErrorCode"
                                                            },
                                                            name: {
                                                                kind: "Name",
                                                                value: "errorCode"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
CouponApplyDocument["definitions"] = _to_consumable_array(new Set(CouponApplyDocument.definitions));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CouponApplyDocument);


/***/ }),

/***/ 63450:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   B: () => (/* binding */ useApplyCouponCallback),
/* harmony export */   s: () => (/* binding */ useApplyCoupon)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83115);
/* harmony import */ var apollo_client__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41146);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83901);
/* harmony import */ var _useCouponData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5881);
/* harmony import */ var _graph_couponApply_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64303);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}





// lightweight variant for applying coupon on payment page
var useApplyCouponCallback = function() {
    var apolloClient = (0,apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useApolloClient */ .x)();
    var resetCouponsCache = (0,_useCouponData__WEBPACK_IMPORTED_MODULE_2__/* .useResetCouponsCache */ .P)();
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = _async_to_generator(function(input) {
            var result, _result_data_couponApply, data, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            apolloClient.mutate({
                                mutation: _graph_couponApply_graphql__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
                                variables: {
                                    input: input,
                                    validateOnly: false,
                                    gender: null
                                },
                                fetchPolicy: "no-cache"
                            })
                        ];
                    case 1:
                        result = _state.sent();
                        resetCouponsCache();
                        // evict applied coupon cache for the cart
                        apolloClient.cache.evict({
                            id: "ROOT_QUERY",
                            fieldName: "purchaseInquiry:InquireSubscriptionCoupon"
                        });
                        if (result.errors) {
                            throw new helpers__WEBPACK_IMPORTED_MODULE_4__/* .GraphQLError */ .__(result.errors);
                        }
                        _result_data_couponApply = result.data.couponApply, data = _result_data_couponApply.data, error = _result_data_couponApply.error;
                        if (error) {
                            throw new helpers__WEBPACK_IMPORTED_MODULE_4__/* .UserError */ .gK(error);
                        }
                        return [
                            2,
                            data
                        ];
                }
            });
        });
        return function(input) {
            return _ref.apply(this, arguments);
        };
    }(), [
        apolloClient,
        resetCouponsCache
    ]);
};
var useApplyCoupon = function() {
    var _useMutation = _sliced_to_array((0,apollo_client__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_graph_couponApply_graphql__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        fetchPolicy: "no-cache"
    }), 2), mutate = _useMutation[0], _useMutation_ = _useMutation[1], isFetching = _useMutation_.isFetching, apolloClient = _useMutation_.client;
    var resetCouponsCache = (0,_useCouponData__WEBPACK_IMPORTED_MODULE_2__/* .useResetCouponsCache */ .P)();
    var submit = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = _async_to_generator(function(input, refetchQueries) {
            var result, _result_data_couponApply, data, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            mutate({
                                variables: {
                                    input: input,
                                    validateOnly: false,
                                    gender: null
                                },
                                refetchQueries: refetchQueries
                            })
                        ];
                    case 1:
                        result = _state.sent();
                        resetCouponsCache();
                        // evict applied coupon cache for the cart
                        apolloClient.cache.evict({
                            id: "ROOT_QUERY",
                            fieldName: "purchaseInquiry:InquireSubscriptionCoupon"
                        });
                        if (result.errors) {
                            throw new helpers__WEBPACK_IMPORTED_MODULE_4__/* .GraphQLError */ .__(result.errors);
                        }
                        _result_data_couponApply = result.data.couponApply, data = _result_data_couponApply.data, error = _result_data_couponApply.error;
                        if (error) {
                            throw new helpers__WEBPACK_IMPORTED_MODULE_4__/* .UserError */ .gK(error);
                        }
                        return [
                            2,
                            data
                        ];
                }
            });
        });
        return function(input, refetchQueries) {
            return _ref.apply(this, arguments);
        };
    }(), [
        mutate,
        resetCouponsCache,
        apolloClient
    ]);
    return [
        submit,
        {
            isFetching: isFetching
        }
    ];
};


/***/ }),

/***/ 28585:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68426);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51827);
/* harmony import */ var cookie_storage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83913);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50556);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




var useCookieCoupon = function(defaultCoupon) {
    var isDefaultCoupon50Enabled = (0,hooks__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z.features.defaultCoupon50);
    var isHoliday22Sub60Enabled = (0,hooks__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z.features.holiday22Sub60);
    var isPlanSelectionInPaymentEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z.abTests.paymentPlanSelection) === "b";
    var fallbackCoupon;
    if (isHoliday22Sub60Enabled) {
        fallbackCoupon = "HD60";
    } else if (isDefaultCoupon50Enabled) {
        fallbackCoupon = isPlanSelectionInPaymentEnabled ? "HD50CRO" : "HD50";
    } else {
        fallbackCoupon = isPlanSelectionInPaymentEnabled ? "HD25CRO" : "HD25";
    }
    var realDefaultCoupon = typeof defaultCoupon === "undefined" ? fallbackCoupon : defaultCoupon;
    var getCookieCoupons = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var cookieCouponCode = cookie_storage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP.getItem(helpers__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z.cookieNames.discountCoupon) // coupon from landings
        ;
        var appliedCouponCode = cookie_storage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP.getItem(helpers__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z.cookieNames.appliedCouponCode);
        var couponCode = cookieCouponCode === undefined ? realDefaultCoupon : cookieCouponCode // cookieCouponCode may be null for "no discount" flow
        ;
        return {
            couponCode: couponCode,
            cookieCouponCode: cookieCouponCode,
            appliedCouponCode: appliedCouponCode
        };
    }, [
        realDefaultCoupon
    ]);
    var setCookieCoupon = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(code) {
        cookie_storage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP.removeItem(helpers__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z.cookieNames.appliedCouponCode);
        cookie_storage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP.setSessionItem(helpers__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z.cookieNames.discountCoupon, code);
        if (code === "FREE_TRIAL") {
            cookie_storage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP.setSessionItem(helpers__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z.cookieNames.isFreeTrialCoupon, true);
        } else {
            cookie_storage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP.removeItem(helpers__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z.cookieNames.isFreeTrialCoupon);
        }
    }, []);
    var data = getCookieCoupons();
    return _object_spread_props(_object_spread({}, data), {
        getCookieCoupons: getCookieCoupons,
        setCookieCoupon: setCookieCoupon
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useCookieCoupon);


/***/ }),

/***/ 5881:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   P: () => (/* binding */ useResetCouponsCache),
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35570);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85183);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52983);
/* harmony import */ var apollo_client__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40454);
/* harmony import */ var apollo_client__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83115);
/* harmony import */ var apollo_client__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36403);
/* harmony import */ var logger__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(58738);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83901);
/* harmony import */ var modules_user__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17382);
/* harmony import */ var _graph_couponApply_graphql__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64303);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}








var modifyResult = function(data) {
    if (!data) {
        return null;
    }
    var coupon = data.coupon, totalAmount = data.totalAmount, couponApplyPeriod = data.couponApplyPeriod;
    return _object_spread_props(_object_spread({}, coupon), {
        totalAmount: totalAmount,
        couponApplyPeriod: couponApplyPeriod
    });
};
// empty object or undefined means the value is fetching, null means it's fetched but not available
var couponDataVar = (0,apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .makeVar */ .QS)({});
var useResetCouponsCache = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        couponDataVar({});
    }, []);
};
// ATTN this hook is for reading-only
var useCouponData = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, userCouponCode = _ref.couponCode, origin = _ref.origin;
    var gender = (0,modules_user__WEBPACK_IMPORTED_MODULE_4__/* .useUser */ .a)().gender;
    var apolloClient = (0,apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useApolloClient */ .x)();
    var couponDataCache = (0,apollo_client__WEBPACK_IMPORTED_MODULE_6__/* .useReactiveVar */ .l)(couponDataVar);
    var couponCode = userCouponCode === null || userCouponCode === void 0 ? void 0 : userCouponCode.toUpperCase();
    var cacheKey = couponCode ? "COUPON-APPLY-".concat(couponCode, "-").concat(gender) : null;
    var rawCouponData = couponDataCache[cacheKey];
    var isDataAvailable = Boolean(rawCouponData) // required to refetch after data reset
    ;
    var couponData = rawCouponData === null || rawCouponData === void 0 ? void 0 : rawCouponData.data;
    var isCouponDataFetching = cacheKey ? couponData === undefined : false;
    var isCouponUnavailable = cacheKey ? couponData === null : false;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var fetchCouponData = function() {
            var _ref = _async_to_generator(function() {
                var result, data, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            if (!couponCode) {
                                return [
                                    2
                                ];
                            }
                            return [
                                4,
                                apolloClient.mutate({
                                    mutation: _graph_couponApply_graphql__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
                                    variables: {
                                        input: {
                                            couponCode: couponCode,
                                            origin: origin,
                                            validateOnly: true
                                        },
                                        gender: gender,
                                        validateOnly: true
                                    },
                                    fetchPolicy: "no-cache"
                                })
                            ];
                        case 1:
                            result = _state.sent();
                            if (result.errors) {
                                throw new helpers__WEBPACK_IMPORTED_MODULE_8__/* .GraphQLError */ .__(result.errors);
                            }
                            data = result.data.couponApply.data;
                            return [
                                2,
                                modifyResult(data)
                            ];
                        case 2:
                            error = _state.sent();
                            logger__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z.info(error);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchCouponData() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!cacheKey) {
            return;
        }
        var lastCacheValue = couponDataVar();
        if (!lastCacheValue[cacheKey]) {
            // data is undefined, but promise is fired
            couponDataVar(_object_spread_props(_object_spread({}, lastCacheValue), _define_property({}, cacheKey, {
                data: undefined
            })));
            fetchCouponData().then(function(data) {
                couponDataVar(_object_spread_props(_object_spread({}, couponDataVar()), _define_property({}, cacheKey, {
                    data: data
                })));
            })["catch"](function() {
                couponDataVar(_object_spread_props(_object_spread({}, couponDataVar()), // reset cache
                _define_property({}, cacheKey, undefined)));
            });
        }
    }, [
        cacheKey,
        origin,
        couponCode,
        apolloClient,
        gender,
        isDataAvailable
    ]);
    return {
        couponData: couponData,
        isCouponDataFetching: isCouponDataFetching,
        isCouponUnavailable: isCouponUnavailable
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useCouponData);


/***/ }),

/***/ 24827:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ coupon_useInquireSubscriptionCoupon)
});

// EXTERNAL MODULE: ./local_modules/apollo-client/hooks/useQuery.ts
var useQuery = __webpack_require__(61420);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.set.js
var es_set = __webpack_require__(41964);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(5119);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(94218);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(40045);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(51497);
;// CONCATENATED MODULE: ./src/modules/coupon/graph/inquireSubscriptionCoupon.graphql.ts
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}





var InquireSubscriptionCouponDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "InquireSubscriptionCoupon"
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "purchaseInquiry"
                        },
                        "arguments": [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "purchaseLevel"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "ALL"
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                "arguments": [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "InquireSubscriptionCoupon",
                                            block: false
                                        }
                                    },
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "filter"
                                        },
                                        value: {
                                            kind: "ListValue",
                                            values: []
                                        }
                                    }
                                ]
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "data"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "items"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "subscription"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "coupon"
                                                                        },
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "code"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
InquireSubscriptionCouponDocument["definitions"] = _to_consumable_array(new Set(InquireSubscriptionCouponDocument.definitions));
/* harmony default export */ const inquireSubscriptionCoupon_graphql = (InquireSubscriptionCouponDocument);

;// CONCATENATED MODULE: ./src/modules/coupon/useInquireSubscriptionCoupon.ts


// returns applied coupon from user's session
var useInquireSubscriptionCoupon = function() {
    var skip = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).skip;
    var _data_purchaseInquiry_data_items_subscription_coupon, _data_purchaseInquiry_data_items_subscription, _data_purchaseInquiry_data_items, _data_purchaseInquiry_data, _data_purchaseInquiry;
    var _useQuery = (0,useQuery/* default */.Z)(inquireSubscriptionCoupon_graphql, {
        ssr: false,
        errorPolicy: "ignore",
        skip: skip
    }), data = _useQuery.data, isFetching = _useQuery.isFetching;
    var inquireSubscriptionCouponCode = data === null || data === void 0 ? void 0 : (_data_purchaseInquiry = data.purchaseInquiry) === null || _data_purchaseInquiry === void 0 ? void 0 : (_data_purchaseInquiry_data = _data_purchaseInquiry.data) === null || _data_purchaseInquiry_data === void 0 ? void 0 : (_data_purchaseInquiry_data_items = _data_purchaseInquiry_data.items) === null || _data_purchaseInquiry_data_items === void 0 ? void 0 : (_data_purchaseInquiry_data_items_subscription = _data_purchaseInquiry_data_items.subscription) === null || _data_purchaseInquiry_data_items_subscription === void 0 ? void 0 : (_data_purchaseInquiry_data_items_subscription_coupon = _data_purchaseInquiry_data_items_subscription.coupon) === null || _data_purchaseInquiry_data_items_subscription_coupon === void 0 ? void 0 : _data_purchaseInquiry_data_items_subscription_coupon.code;
    return {
        inquireSubscriptionCouponCode: inquireSubscriptionCouponCode,
        isFetching: isFetching
    };
};
/* harmony default export */ const coupon_useInquireSubscriptionCoupon = (useInquireSubscriptionCoupon);


/***/ })

}]);